import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import Header from "../../Common/Header";
import { BeneficiaryListForInvitation, GetSendInvitaion } from "../../api/get";
import { InvitationSendToUser } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import * as Yup from "yup";
import { useFormik } from "formik";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { FaInfoCircle } from "react-icons/fa";
import Spinner from "../../Common/Spinner";
import { handleApiError } from "../../Common/Helper";
const Invitation = () => {
  const [contentLoder, setContentLoader] = useState(true);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [loadingEmail, setLoadingEmail] = useState(null); // Track the email for the button clicked
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    BeneficiaryListForInvitation()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setBeneficiaries(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const SendInvitaion = (email) => {
    setLoadingEmail(email); // Set loading for the clicked button
    GetSendInvitaion(email)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          toast.success("Send Email Invitation Successfully.");
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("An error occurred");
      })
      .finally(() => {
        setLoadingEmail(null); // Reset the loading state after the request is done
      });
  };
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      InvitationSendToUser(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            setLoading(false);
            toast.success("Send Email Invitation Successfully.");
            resetForm();
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          toast.error("An error occurred");
        })
        .finally(() => {
          setLoading(false);
          setLoadingEmail(null); // Reset the loading state after the request is done
        });
    },
  });
  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 mt-[15px] max-lg:grid-cols-1">
              <div>
                <div>
                  {beneficiaries?.length > 0 && (
                    <p className="text-[18px] sm:text-[18px] md:text-[20px] lg:text-[22px] font-semibold">
                      Send Invitation to beneficiaries
                    </p>
                  )}
                  {beneficiaries?.length > 0 &&
                    beneficiaries.map((beneficiary, index) => (
                      <div
                        key={index}
                        className="my-5 border-2 py-2 px-2 rounded w-full"
                      >
                        <div className="border-[#d7d7d7] rounded-lg">
                          <div className="flex flex-row items-center w-full gap-4">
                            {/* Image Section */}
                            <div className="w-[15%] max-w-[100px] flex-shrink-0">
                              <img
                                src="/assets/images/icon-mascot.png"
                                alt="The image"
                                className="w-full h-auto object-cover rounded-md"
                              />
                            </div>

                            {/* Content and Button Section */}
                            <div className="flex flex-col w-full md:w-[80%] ml-2 lg:ml-5 md:ml-5">
                              {/* Content Section */}
                              <div className="flex-1">
                                <h4 className="text-[16px] sm:text-[18px] md:text-[18px] lg:text-[18px]  text-black font-bold">
                                  {beneficiary?.beneficiary_first_name}{" "}
                                  {beneficiary?.beneficiary_last_name}
                                </h4>
                                <p className="text-xs sm:text-sm md:text-base lg:text-base">
                                  {beneficiary?.beneficiary_email ||
                                    "No type provided"}{" "}
                                  - {beneficiary?.beneficiary_type}
                                </p>
                              </div>

                              {/* Button Section */}
                              <div className="flex justify-start lg:justify-start mt-2">
                                <button
                                  onClick={() =>
                                    SendInvitaion(
                                      beneficiary?.beneficiary_email
                                    )
                                  }
                                  className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold
                                  text-[14px] sm:text-[16px] md:text-[16px] lg:text-[16px]"
                                  disabled={
                                    loadingEmail ===
                                    beneficiary?.beneficiary_email
                                  }
                                >
                                  {loadingEmail ===
                                  beneficiary?.beneficiary_email
                                    ? "Invitation Sending..."
                                    : "Send Invitation"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <div>
                  <form onSubmit={formik.handleSubmit}>
                    <p className="text-[18px] sm:text-[18px] md:text-[20px] lg:text-[22px] font-semibold">
                      Send Invitation via Email{" "}
                    </p>
                    <div className="grid grid-cols-2 gap-5 ">
                      <div className="mt-5 mb-4 ">
                        <FloatingLabelInput
                          label="First Name"
                          type="text"
                          id="first_name"
                          name="first_name"
                          value={formik.values.first_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.first_name &&
                            formik.errors.first_name
                          }
                        />
                      </div>

                      <div className="mt-5 mb-4 ">
                        <FloatingLabelInput
                          label="Last Name"
                          type="text"
                          id="last_name"
                          name="last_name"
                          value={formik.values.last_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.last_name && formik.errors.last_name
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="Email"
                        type="email"
                        id="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                    {formik.touched.email && formik.errors.email ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {formik.errors.email}
                        </p>
                      </div>
                    ) : null}
                    <div>
                      <button
                        type="submit"
                        className="bg-primary  text-white px-5 py-3 rounded-lg my-5 font-bold"
                      >
                        {loading ? "Invitation Sending..." : "Send Invitation"}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="border-b-2 my-5"></div>
                <div className="pt-5 flex justify-between items-center">
                  <div className="flex  pb-5">
                    <Link to={"/dashboard"}>
                      <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                  </div>
                  <div className="flex  pb-5">
                    <Link to={"/make-will-online/executors/intro-2"}>
                      <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-1">
                        Next <FaChevronRight />
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div>
                <div className="max-lg:hidden bg-no-repeat ">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/10.png" alt="mascot" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Invitation;
